import exactDialogCtrl from "../../dialogs/exactDialog/exactDialog.controller";
import exactDialog from "../../dialogs/exactDialog/exactDialog.html";
import isNil from "lodash/fp/isNil";
import each from "lodash/fp/each";
import cloneDeep from "lodash/fp/cloneDeep";
class Controller {
  constructor($mdDialog, options, selectedDays, Lists, Events) {
    "ngInject";
    this.$mdDialog = $mdDialog;
    this.options = options;
    this.selectedDays = selectedDays;
    this.Lists = Lists.all;
    this.Events = Events;
    this.onAutocompleteSelectEvent = Events.getUpdateEvent(
      "autocompleteSelect"
    );
    // Filter out english because it's static and mandatory to have english name of the city
    this.availableCityLanguages = cloneDeep(this.Lists.availableCityLanguages);
    this.availableCityLanguages = this.availableCityLanguages.filter(
      (lang) => lang.code !== "en"
    );
  }

  $onInit() {
    this.dialogCity = this.options.fields.find(
      (field) => field.resource === "City"
    );
    /** Add default city param to autocomplete fields */
    each((field) => {
      if (field.isResource) {
        field.params = {
          ...field.params,
          city: this.dialogCity && this.dialogCity.value,
        };
      }
    }, this.options.fields);
  }

  close() {
    this.$mdDialog.cancel();
  }

  openExact(option) {
    const add = this.$mdDialog.show({
      controller: exactDialogCtrl,
      controllerAs: "$ctrl",
      template: exactDialog,
      multiple: true,
      locals: {
        option,
      },
    });

    add.then(
      (obj) => {
        option.value = obj;
      },
      () => {}
    );
  }
  onChangeSelect(event, selected) {
    if (!isNil(event) && !isNil(selected)) {
      this.Events.emit(event, selected);
    }
  }
  confirm() {
    this.$mdDialog.hide(this.options);
  }

  handleCityLanguages(field, { isRequired, code }) {
    if (isRequired) {
      field.value.push(code);
    } else {
      const index = field.value.findIndex((lang) => lang === code);
      if (index > -1) field.value.splice(index, 1);
    }
    if (!isNil(field.onChange) && !isNil(field)) {
      this.Events.emit(field.onChange, field);
    }
  }

  handleCompoundSwitch(field, childName, childValue) {
    if (field.requiredOnCount === 1) {
      if (!childValue) {
        const otherChild = field.children.find(
          (child) => child.name !== childName
        );
        otherChild.value = true;
      }
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/addItem/dialog/dialog.controller.js